import { render, staticRenderFns } from "./EnergyPrediction.vue?vue&type=template&id=2f2a55c4"
import script from "./EnergyPrediction.vue?vue&type=script&lang=js"
export * from "./EnergyPrediction.vue?vue&type=script&lang=js"
import style0 from "./EnergyPrediction.vue?vue&type=style&index=0&id=2f2a55c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports